export default __webpack_public_path__ + "img/e48f03c7ee83407be0879aba8ce89bd4.svg";